import { Component, HostBinding, Input, OnInit } from '@angular/core'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { DialogComponent } from './dialog'
import { ModalService } from './modal.service'

@Component({
    selector: 'mg-ui-modal',
    templateUrl: './ui-modal.component.html',
    styleUrls: ['./ui-modal.component.scss'],
})
export class UiModalComponent implements OnInit {
    fileNameDialogRef: MatDialogRef<DialogComponent>

    constructor(public dialog: MatDialog, private modalService: ModalService) {}

    @Input()
    keys: string[]

    @HostBinding('class.isAvailable')
    isAvailable: boolean = false

    data: any = ''

    ngOnInit() {
        const modal = this.modalService.getModal(this.keys)

        if (modal) {
            this.data = modal
            this.isAvailable = true
        }
    }

    openDialog() {
        this.fileNameDialogRef = this.dialog.open(DialogComponent, { data: this.data })
    }
}
